import './Bar.scss';

const MinBar = (props: { stats: any; label: any; minRecomendation: any }) => {
  const { stats, label, minRecomendation } = props;

  return (
    <div>
      <div>{`${label.props.defaultMessage}: ${minRecomendation.props.defaultMessage} (${stats}%)`}</div>
      <div className="rai-assessment__results-bar-enveloper">
        <div
          className="rai-assessment__results-bar-purple"
          style={{ width: `${stats}%` }}
        ></div>
        <div
          className="rai-assessment__results-bar-gray"
          style={{ width: `${100 - stats}%` }}
        ></div>
      </div>
    </div>
  );
};

export default MinBar;
